import isArray from 'lodash/isArray';
import isFunction from 'lodash/isFunction';

/**
 * @ngdoc
 * @description constructor
 * @param isObject - if simple object or collection
 */
function SimpleObservable(isObject) {
  this._observable = isObject ? null : [];
  this._callback = () => {};
}

/**
 * @ngdoc
 * @description add or replace observable object.
 * In case of add object into collection callback will be called with full collection if the callback already registered
 * In case of replace object callback will be called with new object if the callback already registered
 * @param obj
 */
// eslint-disable-next-line func-names
SimpleObservable.prototype.addObject = function (obj) {
  if (isArray(this._observable)) {
    this._observable?.push(obj);
  } else {
    this._observable = obj;
  }

  this._callback(this._observable);
};

/**
 * @ngdoc
 * @description register callback as observer and call the callback immediately
 * @param callback
 */
// eslint-disable-next-line func-names
SimpleObservable.prototype.addObserver = function (callback) {
  if (!isFunction(callback)) {
    throw new Error('callback should be a function.');
  }

  this._callback = callback;
  this._callback(this._observable);
};

/**
 * @ngdoc
 * @description clear function that is set observable into zero state
 * (null in case of simple object, new empty array in case of collection)
 * and remove observer.
 */
// eslint-disable-next-line func-names
SimpleObservable.prototype.clear = function () {
  if (isArray(this._observable)) {
    this._observable = [];
  } else {
    this._observable = null;
  }
  this._callback = () => {};
};

export default SimpleObservable;
